module.exports = "<div *ngIf=\"visible\" class=\"modal-component\">\n\t<div class=\"backdrop\"></div>\n\t<div class=\"modal\"> \n\t\t<div class=\"headline\">{{title}}</div>\n\t\t<div class=\"content\">\n\t\t\t<div class=\"message\">{{msg}}</div>\t\t\n\t\t\t<div class=\"buttons\">\n\t\t\t\t<a id=\"modalOk\" class=\"button--bright-blue\" (click)=\"yesClicked()\">Ok</a>\n\t\t\t\t<a id=\"modalNo\" class=\"button--bright-blue\" (click)=\"noClicked()\">Abbrechen</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/modal/modal.html
// module id = 2j3k
// module chunks = 12